module.exports = __webpack_public_path__ + "static/media/tier-4.2ab4efac.jpg";